<form #formulari="ngForm">
    <div *ngIf="!trasllat.haPagatInscripcio">
        <p i18n>Per tal que la sol·licitud de trasllat sigui efectiva cal abonar el preu de {{<tr></tr>.oferta.importPreinscripcio | currency:'EUR'}} establert per la UdG.</p>
        <p i18n="@@f01f7e1c0cecf91e9e4b1a2dcaf2e7d162704908">Un cop efectuat el pagament rebreu un correu electrònic que confirma la sol·licitud de trasllat.</p>
        <p i18n="@@224fb6246ddbeefee23425cb74fc5bb87f40d175">Per sortir sense finalitzar la sol·licitud tanqueu aquesta finestra. Podreu entrar a la vostra sol·licitud més endavant i efectuar el pagament.</p>
        <p i18n="@@e197057cf8f181291eca9be59db4c9110c234244">Si no podeu pagar amb targeta de crèdit, adreceu-vos a <a href="mailto:sga@udg.edu" target="_blank">sga@udg.edu</a></p>    
        <p i18n>A continuació et redirigirem al servei de pagament de la Universitat de Girona per tal que puguis realitzar el pagament de la inscripció.</p>        
    </div>
    <div *ngIf="trasllat.haPagatInscripcio">
        <p i18n>Ja s'ha abonat l'import de {{<tr></tr>.oferta.importPreinscripcio | currency:'EUR'}} establert per la UdG com a taxa d'inscripció.</p>
    </div>
    <mat-grid-list cols="4" rowHeight="80px" *ngIf="trasllat.potModificar">                      
        <mat-grid-tile colspan="4">
            <div class="pre-controls-right">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>                                
</form>


// WEBPACK FOOTER //
// ./src/app/pagament/pagament.component.html